<template>
  <div class="page">
    <div class="sidebar">
      <PatchSidebar />
    </div>

    <div class="page__content">
      <slot name="canvas"></slot>

      <JacketViewSwitcher></JacketViewSwitcher>
    </div>
  </div>
</template>

<script>
import JacketViewSwitcher from '@/components/jacket/JacketViewSwitcher.vue';
import PatchSidebar from '@/components/jacket/sidebars/PatchSidebar.vue';

export default {
  name: 'PatchesPage',
  components: {
    PatchSidebar,
    JacketViewSwitcher,
  }
};
</script>

<style scoped>
  .page__content {
    padding-top: 67px;
  }
</style>
